import loadingBars from '@fd-assets/core-styles/client/loadingBars';

import errorNotification from '@grins/fd-modules/bonz/modules/errorNotification';
import bonzConsts from '@grins/fd-modules/bonz/shared/constants';

import Fandango_triggerEvent_triggerAnalyticsEvent from '@grins/fd-modules/Fandango/triggerEvent';

import inputValidator from '@grins/fd-modules/shared/inputValidator';

import {
  Fandango_xhr as xhr,
  fd_url_manager as links,
  focusableInput_form as focusableForm
} from '@grins/fd-modules/splits/onering-global';

type ForgotPasswordFields = HTMLFormControlsCollection & {
  email: HTMLInputElement;
};

const { triggerAnalyticsEvent } = Fandango_triggerEvent_triggerAnalyticsEvent;

const Selectors = {
  FORM_CONTAINER: '#forgot-pwd-form-container',
  FORM: '#forgot-pwd-form',
  SAVE_BTN: '#forgot-pwd-submit-btn',
  SUCCESS_CONTAINER: '#forgot-pwd-success-container',
};

const Styles = {
  HIDE: 'hide',
  LOADING_FULL: 'btn--loading-wrap',
};

const baseAnalyticsData = {
  pageType: 'forgot password',
  pageName: 'account | forgot password',
};

const Msgs = {
  GENERIC_ERROR: 'Something went wrong on our end.  Please try again later.',
};

function setSaving(isSaving: boolean) {
  const saveBtn = document.querySelector(Selectors.SAVE_BTN);

  if (isSaving) {
    loadingBars.start(saveBtn, { className: Styles.LOADING_FULL });
  } else {
    loadingBars.stop(saveBtn);
  }
}

function trackError(errorMessage: string) {
  const eventName = bonzConsts.OmnitureEvents.FORGOT_ERROR;
  triggerAnalyticsEvent('Forgot Password Error', { ...baseAnalyticsData, event: eventName, eventName, errorMessage });
}

function onFail() {
  setSaving(false);
  trackError(Msgs.GENERIC_ERROR);
  errorNotification.show(Msgs.GENERIC_ERROR);
}

function onDone(response?: { success?: boolean }) {
  setSaving(false);

  if (!response || !response.success) {
    return trackError(Msgs.GENERIC_ERROR);
  }

  const eventName = bonzConsts.OmnitureEvents.FORGOT_COMPLETE;
  const successPageName = 'account | forgot password | complete';

  triggerAnalyticsEvent(successPageName, {
    ...baseAnalyticsData,
    event: 'pageview',
    eventName,
    pageName: successPageName,
    pageType: 'forgot password complete',
    server: 'fandango web accounts'
  });

  document.querySelector(Selectors.FORM_CONTAINER)!.classList.add(Styles.HIDE);
  document.querySelector(Selectors.SUCCESS_CONTAINER)!.classList.remove(Styles.HIDE);
}

function validateFields(fields: ForgotPasswordFields) {
  const { ValidationTypes, validate } = inputValidator;
  const { email } = fields;
  const validationRules = [{ input: email, isRequired: true, type: ValidationTypes.EMAIL }];
  const { hasErrors, errors } = validate(validationRules);
  return { errors, hasErrors, msg: !hasErrors ? '' : errors.map(({ error }) => error).join('<br>') };
}

async function onSubmit(this: HTMLFormElement, e: SubmitEvent) {
  e.preventDefault();
  setSaving(true);
  const fields = this.elements as ForgotPasswordFields;
  const { hasErrors, errors } = validateFields(fields);

  if (hasErrors) {
    setSaving(false);
    return focusableForm.toggleErrors(errors ?? [], true);
  }

  const data = {
    email: fields.email.value,
  };

  xhr.ajax({ url: links.snapiBonzForgotPassword(), method: 'POST', data })?.done(onDone).fail(onFail);
}

function init() {
  const form = document.querySelector<HTMLFormElement>(Selectors.FORM)!;
  form.addEventListener('submit', onSubmit);
  focusableForm.attach(form);
}

export default {
  init
};
